import { useNavigate } from 'react-router-dom';
import { ArrowRight } from '@tapsioss/react-icons';
import { Fn } from 'common/types.ts';
import { TEST_IDS } from 'src/common/testId';
import { IconButton } from '@tapsioss/react-components/IconButton';

export interface Props {
  hasShadow?: boolean;
  hasBackground?: boolean;
  onBackClick?: Fn;
}

const Back = ({ hasShadow, hasBackground, onBackClick }: Props) => {
  const navigate = useNavigate();
  const background = hasBackground ? '#fff' : 'transparent';
  return (
    <IconButton
      onClick={() => (onBackClick ? onBackClick() : navigate(-1))}
      style={{ background: background }}
      variant={hasShadow ? 'elevated' : 'naked'}
      data-testid={TEST_IDS.layout.backButton}
    >
      <ArrowRight size={24} />
    </IconButton>
  );
};

export default Back;
